<template>
  <div class="template-connected">
    <div id="container">
      <div class="block-flat ">
        <div class="block-content ">
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(save)">
              <fieldset>
                <legend>
                  Zone
                </legend>
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Code <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="code zone"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.ZONE_CODE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Commune insee :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="data.ZONE_COMMUNE_INSEE"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Consigne :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input v-model="data.ZONE_CONSIGNE"></b-form-input>
                  </b-col>
                </b-row>
              </fieldset>
              <fieldset>
                <legend>
                  OUVRAGE
                </legend>
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Code <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="Code ouvrage"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.OUVRAGE_CODE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Dénomination <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="Dénomination"
                    >
                      <b-form-textarea
                        :state="errors[0] ? false : null"
                        v-model="data.OUVRAGE_DENOMINATION"
                      ></b-form-textarea>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    <p>CATÉGORIES D’OUVRAGES SENSIBLES POUR LA SÉCURITÉ : <blockquote>–
                    CANALISATIONS DE TRANSPORT ET CANALISATIONS MINIÈRES
                    CONTENANT DES HYDROCARBURES LIQUIDES OU LIQUÉFIÉS, OU DES
                    PRODUITS CHIMIQUES LIQUIDES OU GAZEUX</blockquote> <blockquote>– CANALISATIONS DE
                    TRANSPORT ET CANALISATIONS MINIÈRES CONTENANT DES PRODUITS
                    CHIMIQUES LIQUIDES OU GAZEUX</blockquote><blockquote> – CANALISATIONS DE TRANSPORT,
                    DE DISTRIBUTION ET CANALISATIONS MINIÈRES CONTENANT DES GAZ
                    COMBUSTIBLES</blockquote> <blockquote>– CANALISATIONS DE TRANSPORT OU DE DISTRIBUTION
                    DE VAPEUR D’EAU, D’EAU SURCHAUFFÉE, D’EAU CHAUDE, D’EAU
                    GLACÉE, OU DE TOUT AUTRE FLUIDE CALOPORTEUR OU FRIGORIGÈNE</blockquote> <blockquote>–
                    LIGNES ÉLECTRIQUES, RÉSEAUX D’ÉCLAIRAGE PUBLIC ET RÉSEAUX DE
                    SIGNALISATION ROUTIÈRE</blockquote> <blockquote>– INSTALLATIONS DESTINÉES À LA
                    CIRCULATION DE VÉHICULES DE TRANSPORT PUBLIC GUIDÉ
                    (TRANSPORT FERROVIAIRES, MÉTROS, TRAMWAYS, TÉLÉPHÉRIQUES …)
                    </blockquote><blockquote>– CANALISATIONS DE TRANSPORT DE DÉCHETS PAR DISPOSITIF
                    PNEUMATIQUE SOUS PRESSION OU PAR ASPIRATION..</blockquote></p> <p>CATÉGORIE
                    D’OUVRAGES SENSIBLES POUR LA VIE ÉCONOMIQUE : <blockquote>–
                    INSTALLATIONS SOUTERRAINES DE COMMUNICATIONS ÉLECTRONIQUES
                    CATÉGORIES D’OUVRAGES NON SENSIBLES POUR LA SÉCURITÉ : </blockquote><blockquote> –
                    CANALISATIONS SOUTERRAINES DE PRÉLÈVEMENT ET DE DISTRIBUTION
                    D’EAU DESTINÉE À LA CONSOMMATION HUMAINE, EN PRESSION OU À
                    ÉCOULEMENT LIBRE, Y COMPRIS LES RÉSERVOIRS D’EAU ENTERRÉS
                    QUI LEUR SONT ASSOCIÉS  </blockquote><blockquote>– CANALISATIONS SOUTERRAINES
                    D’ASSAINISSEMENT, CONTENANT DES EAUX USÉES DOMESTIQUES OU
                    INDUSTRIELLES OU DES EAUX PLUVIALES</blockquote></p>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Catégorie <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="Ouvrage catégorie"
                    >
                      <b-form-select
                        :options="categories"
                        :state="errors[0] ? false : null"
                        v-model="data.OUVRAGE_CATEGORIE"
                      ></b-form-select>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    <p>
                      RÈGLES À RESPECTER : LES OUVRAGES AYANT POUR TYPE UN
                      CHIFFRE ALLANT DE 1 À 7 SONT NÉCESSAIREMENT DE CATÉGORIE «
                      S » POUR SENSIBLE. LES OUVRAGES AYANT POUR TYPE UN NOMBRE
                      ALLANT DE 8 À 11 PEUVENT ÊTRE DE CATÉGORIE « NS » POUR NON
                      SENSIBLE OU « NSFS » POUR NON SENSIBLE FORCÉ SENSIBLE.
                    </p>
                    <p>
                      LE TYPE D’OUVRAGE CORRESPONDANT AU CHIFFRE 11 POUVANT
                      REPRÉSENTER SOIT UN RÉSEAU SENSIBLE, SOIT UN RÉSEAU NON
                      SENSIBLE.
                    </p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Catégorie <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="type d'ouvrage"
                    >
                      <b-form-select
                        :options="types"
                        :state="errors[0] ? false : null"
                        v-model="data.OUVRAGE_TYPE"
                      ></b-form-select>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Acheminement :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-select
                      :options="acheminements"
                      v-model="data.OUVRAGE_ACHEMINEMENT"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Positionnement :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-select
                      :options="positionnements"
                      v-model="data.OUVRAGE_POSITIONNEMENT"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    <p>
                      EN CAS DE NON RENSEIGNEMENT, L’OUVRAGE CORRESPONDANT
                      SERAIT CONSIDÉRÉ COMME « ACTIF ».
                    </p>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >État <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="état"
                    >
                      <b-form-select
                        :options="etats"
                        :state="errors[0] ? false : null"
                        v-model="data.OUVRAGE_ETAT"
                      ></b-form-select>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </fieldset>
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label"
                    >Longueur total réseaux <span class="red">*</span> :</label
                  >
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="état"
                  >
                    <b-form-radio-group
                      v-model="data.LONGUEUR_TOTALE_RESEAUX"
                      :options="longueurs"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                  <p>
                    FACULTATIVE DANS LE CAS OÙ LA LONGUEUR DES RÉSEAUX NON
                    SENSIBLES EST INFÉRIEURE À 500 KM
                  </p>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label"
                    >DÉCLARATIONS DÉMATÉRIALLISÉES<span class="red">*</span>
                    :</label
                  >
                </b-col>
                <b-col lg="10" md="9" sm="12" cols="12">
                  <b-form-radio-group
                    v-model="data.DECLARATIONS_DEMATERIALISEES"
                    :options="declarations"
                  />
                </b-col>
              </b-row>
              <fieldset>
                <legend>
                  CONTACT
                </legend>
                <b-row>
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <p>
                      PERMETTENT DE PRÉCISER L’ADRESSE OÙ DOIVENT ÊTRE ENVOYÉES
                      LES DÉCLARATIONS DT/DICT.
                    </p>
                    <p>
                      SI VOUS DÉLÉGUEZ LA GESTION DES DT/DICT À UN TIERS, VOUS
                      DEVREZ INDIQUER LES COORDONNÉES DU CONTACT EN AYANT LA
                      CHARGE.
                    </p>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Code<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="Code contact"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_CODE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Prénom :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                    <b-form-input v-model="data.CONTACT_PRENOM"></b-form-input>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Nom (en majuscule) :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                    <b-form-input v-model="data.NOM"></b-form-input>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Société<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="Société"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_SOCIETE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">AGENCE :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                    <b-form-input v-model="data.CONTACT_AGENCE"></b-form-input>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Complément d'adresse<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="complément d'adresse"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_CMPLT_ADRESSE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Adresse<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="adresse"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_ADRESSE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Lieu dit<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="lieu dit"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_LIEUDIT"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >code postal<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="code postal"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_CP"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Commune<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="commune"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_COMMUNE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Pays<span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="pays"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_PAYS"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    NUMÉRO SANS SÉPARATEUR
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Téléphone <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="téléphone"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_TEL"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    NUMÉRO SANS SÉPARATEUR
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Fax <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="fax"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_FAX"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Courriel <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required|email"
                      name="courriel"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_COURRIEL"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Site :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input v-model="data.CONTACT_SITE"></b-form-input>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    NUMÉRO SANS SÉPARATEUR
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Téléphone urgence :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="data.CONTACT_TEL_URGENCE"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    NUMÉRO SANS SÉPARATEUR
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Fax urgence <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="fax urgence"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_FAX_URGENCE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Courriel urgence <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required|email"
                      name="courriel urgence"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_COURRIEL_URGENCE"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label"
                      >Téléphone endommagement
                      <span class="red">*</span> :</label
                    >
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <ValidationProvider
                      mode="lazy"
                      v-slot="{ errors }"
                      rules="required"
                      name="t&éléphone endommagement"
                    >
                      <b-form-input
                        :state="errors[0] ? false : null"
                        v-model="data.CONTACT_TEL_ENDOMMAGEMENT"
                      ></b-form-input>
                      <div class="error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    <p>
                      AJOUTER UN COMMENTAIRE OU UNE CONSIGNE AU SUJET DE
                      L’OUVRAGE.
                    </p>
                    <p>
                      CE PEUT ÊTRE UNE CONSIGNE DE SÉCURITÉ OU UNE PRÉCISION SUR
                      LA POSITION DE L’OUVRAGE.
                    </p>
                    <p>
                      CHAQUE CONSIGNE EST LIÉE À UN CONTACT ET CONCERNERA TOUTES
                      LES COMMUNES RATTACHÉES À CE CONTACT.
                    </p>
                    <p>EXEMPLE : NE CONTACTER QUE POUR LA ZONE EST.</p>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">Consigne :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="data.CONTACT_CONSIGNE"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    PERMET DE RETROUVER PLUS AISÉMENT UN CONTACT.
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">RÉFÉRENCE INTERNE :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="data.CONTACT_REFERENCE_INTERNE"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
                    <p>
                      CETTE INFORMATION EST À RENSEIGNER OBLIGATOIREMENT
                      PUISQU’ELLE PRÉCISE LA PRISE EN COMPTE OU NON D’UNE ZONE
                      D’IMPLANTATION SUR UNE OU PLUSIEURS COMMUNES.
                    </p>
                    <p>
                      LORS DE L’IMPORT D’UNE ZONE D’IMPLANTATION SUR UN OUVRAGE
                      CONCERNANT PLUSIEURS COMMUNES, SI « NON » EST RENSEIGNÉ
                      POUR UNE OU PLUSIEURS COMMUNES, ELLES NE SERONT PAS PRISES
                      EN COMPTE LORS DE L’IMPORT DE LA ZONE D’IMPLANTATION.
                    </p>
                  </b-col>
                  <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                    <label class="control-label">PRISE EN COMPTE ZIO :</label>
                  </b-col>
                  <b-col lg="10" md="9" sm="12" cols="12">
                    <b-form-radio-group v-model="data.ZIO" :options="zios" />
                  </b-col>
                </b-row>
              </fieldset>
              <b-col lg="10" md="9" sm="12" cols="12" class="text-center">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-auto marginBottom-15"
                >
                  <font-awesome-icon icon="check"></font-awesome-icon>
                  Valider
                </b-button>
              </b-col>
            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import historyTimeline from "../components/historyTimeline.vue";
export default {
  methods: {
    save() {
      var items = [this.data];
      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      const header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(header.join(","));
      csv = csv.join("\r\n");

      //Download the file as CSV
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      let dateObj = new Date();
    let month = dateObj.getMonth()+1;
    let day = String(dateObj.getDate()).padStart(2, '0');
    let year = dateObj.getFullYear();
    let output = year  + '_'+ month  + '_' + day;
      downloadLink.download = output+" Déclaration Ineris.csv"; //Name the file here
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
  },
  data: () => ({
    data: {
      ZONE_CODE: "",
      ZONE_COMMUNE_INSEE: "",
      ZONE_CONSIGNE: "",
      OUVRAGE_CODE: "",
      OUVRAGE_DENOMINATION: "",
      OUVRAGE_CATEGORIE: "",
      OUVRAGE_TYPE: "",
      OUVRAGE_SOUS_TYPE: "",
      OUVRAGE_ACHEMINEMENT: "",
      OUVRAGE_POSITIONNEMENT: "",
      OUVRAGE_ETAT: "",
      LONGUEUR_TOTALE_RESEAUX: "",
      DECLARATIONS_DEMATERIALISEES: "",
      CONTACT_CODE: "",
      CONTACT_PRENOM: "",
      CONTACT_NOM: "",
      CONTACT_SOCIETE: "",
      CONTACT_COMMUNE: "",
      CONTACT_CP: "",
      CONTACT_LIEUDIT: "",
      CONTACT_CMPLT_ADRESSE: "",
      CONTACT_AGENCE: "",
      CONTACT_SOCIETE: "",
      CONTACT_ADRESSE: "",
      CONTACT_PAYS: "France",
      CONTACT_CONSIGNE: "",
      CONTACT_TEL: "",
      CONTACT_FAX: "",
      CONTACT_COURRIEL: "",
      CONTACT_SITE: "",
      CONTACT_TEL_URGENCE: "",
      CONTACT_FAX_URGENCE: "",
      CONTACT_COURRIEL_URGENCE: "",
      CONTACT_TEL_ENDOMMAGEMENT: "",
      CONTACT_REFERENCE_INTERNE: "",
      ZIO: "",
    },
    zios: [
      { text: "OUI", value: "OUI" },
      { text: "NON", value: "NON" },
    ],
    declarations: [
      { text: "XML normalisé", value: 1 },
      { text: "PDF et XML normalisé", value: 2 },
    ],
    longueurs: [
      { text: "Inférieur ou égal à 500km", value: 1 },
      { text: "Supérieur à 500km", value: 2 },
    ],
    etats: [
      { text: "Ouvrage inactif", value: 1 },
      { text: "Ouvrage actif", value: 2 },
      { text: "Ouvrage abandonné", value: 3 },
      { text: "Ouvrage supprimé", value: 4 },
    ],
    positionnements: [
      { text: "Ouvrage strictement souterrain", value: 1 },
      { text: "Ouvrage strictement aérien", value: 2 },
      { text: "Ouvrage aérien et souterrain", value: 3 },
    ],
    acheminements: [
      { text: "Transport", value: 1 },
      { text: "Distribution", value: 2 },
    ],
    categories: [
      { text: "Sensible", value: "S" },
      { text: "Non Sensible", value: "NS" },
      { text: "Non Sensible Forcé Sensible", value: "NSFS" },
    ],
    types: [
      { text: "Canalisations d’hydrocarbures liquides ou liquéfiés", value: 1 },
      {
        text: "Canalisations de produits chimiques liquides ou gazeux",
        value: 2,
      },
      { text: "Canalisations de gaz combustibles", value: 3 },
      { text: "Réseaux de chaleurs ou de froid", value: 4 },
      {
        text:
          "Lignes électriques, réseaux d’éclairage public et réseaux de signalisation routière",
        value: 5,
      },
      { text: "Installations de transport guidé", value: 6 },
      { text: "Canalisations et transport de déchets", value: 7 },
      { text: "Installations de communications électroniques", value: 8 },
      { text: "Canalisations d’eau potable", value: 9 },
      { text: "Canalisations d’eaux usées ou d’assainissement", value: 10 },
      { text: "Autre", value: 11 },
    ],
  }),
};
</script>

<style></style>
